import Axios from '@/libs/http';
import vc from "vue-cookie"
import { cookieExpires,baseMsgurl } from "@/libs/config"
import router from '@/router'
import local from '@/libs/localStorage'

export default {
  state:{
    verifyShow: false,
    userInfo: {},
    waitMeUserInfo: {},
    pathInfo: local.get('signpath') || {}
  },
  getters:{
 
  },
  mutations:{
    setToken(state, params){
      state.userInfo = params.data
      local.set('sapiInfo', params.data)
    },
    setWaitMeUserInfo(state, params){
      state.waitMeUserInfo = params.data
      local.set('waitMeUserInfo', params.data)
    },
    setSignPath(state, params){
      state.pathInfo = params.data
      local.set('signpath', params.data)
    },
    delToken(){
      local.remove('sapiInfo')
    },
    setverifyShow(state, params){
      state.verifyShow = params
    }
  },
  actions:{
    async handleLog ({ state, commit },params){
      let result = await Axios.post(params.url, params.params)
      return {
        ...result
      }
    },
    setSignPath({ commit },params){
      commit('setSignPath',params)
    },
    setverifyShow ({ commit },params){
      commit('setverifyShow',params)
    },
    noTokenLogOut({ state, commit ,dispatch},params){
      commit('delToken', true)
      router.replace({
        name: 'invalid'
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/module/user.js